"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTab = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _Text = require("../Text");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BaseTabActiveMixin = (0, _styledComponents.css)(["outline:0;color:", ";border-bottom-color:", " !important;"], (0, _helpers.color)("black100"), (0, _helpers.color)("black100"));
/**
 * Extends `Text`. Should always be nested within a `BaseTabs` container.
 *
 * Use the `as` prop to alter behavior.
 * E.g.: `<BaseTab as={RouterLink} to="/foo">Foo</BaseTab>`
 * or `<BaseTab as={Clickable} onClick={handleClick}>Foo</BaseTab>`
 */

var BaseTab = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "BaseTab",
  componentId: "sc-1qn17bx-0"
})(["display:block;width:100%;position:relative;text-decoration:none;white-space:nowrap;z-index:1;color:", ";", " &:focus,&.active{", "}&:focus{color:", ";}"], (0, _helpers.color)("black60"), function (_ref) {
  var active = _ref.active;
  return active && BaseTabActiveMixin;
}, BaseTabActiveMixin, (0, _helpers.color)("purple100"));
exports.BaseTab = BaseTab;
BaseTab.defaultProps = {
  variant: "mediumText",
  mb: "-1px",
  pb: 1.5,
  borderBottom: "2px solid",
  borderColor: "transparent"
};
BaseTab.displayName = "BaseTab";
//# sourceMappingURL=BaseTab.js.map